<template>
    <ticket-preview :class_add_in_row=4 :break_row=3></ticket-preview>
</template>
<script>
export default {
    name:'PrintTicketView',
    components:{
        'ticket-preview': () => import("@/components/frontend/event-booking/TicketPreview.vue"),
    },mounted(){
        setTimeout(()=>{
            window.print();
            setTimeout(()=>{
                window.close();
            },500);
        },2000);
    }
}
</script>